<template>
    <nav v-if="items" class="breadcrumbs" aria-label="Breadcrumb">
        <ul>
            <li
                v-for="(item, index) in items"
                :class="{ home: item.home }"
                :key="index"
            >
                <font-awesome-icon
                    class="breadcrumb-chevron mx-2"
                    icon="fas fa-chevron-right"
                    v-if="index !== 0"
                />
                <a :href="item.url" class="breadcrumb-link" :aria-label="item.label || 'Home'">
                    <font-awesome-icon
                        v-if="item.icon"
                        class="breadcrumb-icon"
                        :icon="item.icon"
                    />
                    <span class="breadcrumb-text">
                        {{ item.label }}
                    </span>
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'Breadcrumbs',
    components: {},
    computed: {
        ...mapGetters(['wizardData', 'focusedBlock', 'selectedLanguage','translations']),
    },
    data() {
        return {
            items: null,
        };
    },
    methods: {
        populateBreadcrumbs() {
            let breadcrumbItems = [
                {
                    home: true,
                    icon: 'fas fa-home-lg fs-5',
                    label: '',
                    url: `/${this.selectedLanguage}/`,
                },
            ];
            if (location.href.includes('wizard') && this.wizardData) {
                breadcrumbItems.push({
                    label:
                        this.wizardData.status === 'DRAFT'
                            ? this.$t('lib_register_application')
                            : this.$t('lib_edit_application'),
                    url: null,
                });
                if (this.focusedBlock) {
                    breadcrumbItems.push({
                        label: this.focusedBlock.label,
                        url: null,
                    });
                }
            } else if (location.href.includes('cookies')) {
                breadcrumbItems.push({
                    label: this.$t('lib_cookies'),
                    url: null,
                });
            } else if (
                location.pathname.toLocaleLowerCase().includes('application')
            ) {
                breadcrumbItems.push({
                    label: this.$t('lib_application'),
                    url: null,
                });
            } else if (location.pathname.toLocaleLowerCase().includes('todo')) {
                breadcrumbItems.push({
                    label: this.$t('lib_pending_actions'),
                    url: null,
                });
            }
            this.items = breadcrumbItems;
        },
    },
    mounted() {
        this.populateBreadcrumbs();
    },
    watch: {
        wizardData: {
            handler() {
                this.populateBreadcrumbs();
            },
            deep: true,
        },
        focusedBlock: {
            // focusedBlock is used only in wizard to show the name of the focused block in the breadcrumbs;
            handler() {
                this.populateBreadcrumbs();
            },
            deep: true,
        },
        translations: {
            // focusedBlock is used only in wizard to show the name of the focused block in the breadcrumbs;
            handler() {
                this.populateBreadcrumbs();
            },
            deep: true,
        },
    },
};
</script>
